import * as React from "react";
import {useRef, useState} from "react";
import "./index.scss";

interface IProps {
    type: string;
    placeholder: string;
    value: string;
    fieldName: string;
    onChange: (value: string) => void;
    label?: string;
    min?: number;
    max?: number;
    maxLength?: number;
    errorMsg?: string;
    disabled?: boolean;
}

export const TextField = (props: IProps) => {
    const inputRef = useRef(null);
    const [focus, changeFocus] = useState(false);
    return (
        <div className="consent-text-field-container">
            {props.label ?
                <div className="label">
                    {props.label}
                </div> : null}
            <div className={`text-field flex-center-row ${focus ? " active" : ""}`}>
                <input
                    id={props.fieldName}
                    ref={inputRef}
                    type={props.type}
                    placeholder={props.placeholder}
                    value={props.value !== null ? props.value : ""}
                    min={props.min}
                    max={props.max}
                    maxLength={props.maxLength}
                    disabled={props.disabled}
                    onChange={(e) => props.onChange(e.target.value)}
                    onFocus={() => changeFocus(true)}
                    onBlur={() => changeFocus(false)}
                />
            </div>
            {props.errorMsg ?
                <div className="error-message flex-center-row">
                    {props.errorMsg}
                </div> : null}
        </div>
    );
};

export default TextField;
